import { PrintableEvent, TableColumn, TableSelectionEvent, Textbox } from "@mcleod/components";
import { MapSettings } from "@mcleod/core";
import { getDispatchControlBoolean } from "@mcleod/general";
import { AutogenLayoutZipZoneList } from "./autogen/AutogenLayoutZipZoneList";
import { MapZoneSelectionUtil } from "./MapZoneSelectionUtil";
import { ZoneMapScreen } from "./MapZoneUtil";

export class ZipZoneList extends AutogenLayoutZipZoneList {
    private mapVendor = MapSettings.getSingleton().getZoneMapVendor();
    private mapSelector: MapZoneSelectionUtil;

    override async onLoad(): Promise<void> {
        this.mainDataSource.search();
        this.mapSelector = new MapZoneSelectionUtil(this.mapVendor, this.mapRoute);
        this.toggleDistanceColumn();
    }

    private toggleDistanceColumn() {
        const column: TableColumn = this.tableZipZoneList.getColumnByCaption("Empty Distance Override");
        const isEmptyDispatchOverride = getDispatchControlBoolean("enable_empty_dist_override");
        if (column && !isEmptyDispatchOverride) {
            this.tableZipZoneList.removeColumn(column);
        }
    }

    async tableZipZoneListOnSelect(event: TableSelectionEvent) {
        await this.mapSelector.handleRowSelection(ZoneMapScreen.ZipZone, this.tableZipZoneList.selectedRow);
    }

    textboxEmptyDistanceOverrideOnPrintable(event: PrintableEvent) {
        const textbox = event.target as Textbox;
        if (textbox != null) {
            textbox.fillRow = true;
        }
    }

}
